import { LoadingButton } from '@mui/lab';
import { Avatar, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const Styled = {
    Container: styled(Box)(({ theme }) => {
        return {
            display: 'flex',
            justifyContent: 'center',
        };
    }),
    CardImage: styled(Avatar)(({ theme }) => {
        return {
            width: '100%',
            minHeight: '200px',
            maxHeight: '200px',
            height: '100%',
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                '& .MuiAvatar-img': {
                    maxHeight: '200px',
                },
            },

        };
    }),
    UploaderContainer: styled(Box)(({ theme }) => {
        return {
            width: '100%',
            marginRight: 0,
            borderRadius: '10px',
            transition: 'color 0.2s ease',
            [theme.breakpoints.down('sm')]: {
                marginBottom: theme.spacing(1),
            },
        };
    }),
    UploaderFieldTemplate: styled(Box)(({ theme }) => {
        return {
            width: '100%',
            height: 'auto !important',
            display: 'flex',
            justifyContent: 'end',
            position: 'absolute',
            right: 5,
            top: 10,
            zIndex: 12,
            i: {
                textShadow: '1px 1px 4px #4f0e0e',
            },
        };
    }),
    LoadingButton: styled(LoadingButton)(() => {
        return {
            zIndex: 1,
            position: 'absolute',
            bottom: 30,
            i: {
                marginRight: 10,
            },
        };
    }),
};

export { Styled };
